import {FLink} from "../components/other/FurtherLinks";
import {blogImg, linkedInImg, webImg} from "./imgLinks";

export const sailHackathonPresse: FLink[] = [
    {
        url: "https://www.linkedin.com/posts/cluster-medizin-nrw_bielefeld-hackathon-ai-in-health-sciences-activity-7399103461671460864-1sT9",
        text: "LinkedIn",
        linktitle: "Bielefeld Hackathon: AI in Health Sciences",
        img: linkedInImg
    },
    {
        url: "https://www.sail.nrw/2025/11/sail-hackathon-ai-in-health-sciences/",
        text: "Sail NRW",
        linktitle: "SAIL Hackathon: AI in Health Sciences",
        img: blogImg
    },
    {
        url: "https://www.hsbi.de/presse/pressemitteilungen/hackathon-ai-in-health-sciences-kann-ein-ki-algorithmus-bewegungen-auf-basis-von-gehirnstroemen-erkennen",
        text: "HSBI",
        linktitle: "Hackathon: Kann ein KI-Algorithmus Bewegungen auf Basis von Gehirnströmen erkennen?",
        img: blogImg
    },
    {
        url: "https://www.hsbi.de/media/hochschulverwaltung/hsk/bilder-berichterstattung/fachbereiche/fb-3/forschung/2025-11-09-sail-hackathon/20251109_hackathon-sail_doerk_slider-pano.jpg?height=278&width=840",
        text: "HSBI",
        linktitle: "SAIL Hackathon – AI in Health Sciences",
        img: blogImg
    },
    {
        url: "https://www.krankenhaus-it.de/item.4686/hackathon-an-der-hsbi-ki-modelle-erkennen-bewegungen-aus-eeg-daten.html",
        text: "Krankenhaus-IT",
        linktitle: "Hackathon an der HSBI: KI-Modelle erkennen Bewegungen aus EEG-Daten",
        img: webImg
    },
    {
        url: "https://nachrichten.idw-online.de/2025/11/24/hackathon-kann-ein-ki-algorithmus-bewegungen-auf-basis-von-gehirnstroemen-erkennen",
        text: "idw",
        linktitle: "Hackathon: Kann ein KI-Algorithmus Bewegungen auf Basis von Gehirnströmen erkennen?",
        img: webImg
    }
];